import type {GraphClientPoint} from '@/types/components/remoteCursors.types';

type GraphPointLike = {
	clientToLocal?: (x: number, y: number) => {x?: number; y?: number} | null;
	localToClient?: (x: number, y: number) => {x?: number; y?: number} | null;
	coord?: {
		clientToLocalPoint?: (x: number, y: number) => {x?: number; y?: number} | null;
		localToClientPoint?: (x: number, y: number) => {x?: number; y?: number} | null;
	};
};

function toPoint(p: {x?: number; y?: number} | null | undefined): GraphClientPoint | null {
	if (p == null) return null;
	const x = Number(p.x);
	const y = Number(p.y);
	if (!Number.isFinite(x) || !Number.isFinite(y)) return null;
	return {x, y};
}

export function graphClientToLocal(
	graph: GraphPointLike | null | undefined,
	clientX: number,
	clientY: number
): GraphClientPoint | null {
	if (!graph) return null;
	const p =
		typeof graph.clientToLocal === 'function'
			? graph.clientToLocal(clientX, clientY)
			: graph.coord?.clientToLocalPoint?.(clientX, clientY);
	return toPoint(p);
}

export function graphLocalToClient(
	graph: GraphPointLike | null | undefined,
	x: number,
	y: number
): GraphClientPoint | null {
	if (!graph) return null;
	const p =
		typeof graph.localToClient === 'function'
			? graph.localToClient(x, y)
			: graph.coord?.localToClientPoint?.(x, y);
	return toPoint(p);
}
